import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserAlt, faFilm } from '@fortawesome/free-solid-svg-icons'

const NavData = [
    {
        title: 'Movies',
        path: '/home',
        icon: (<FontAwesomeIcon icon={faFilm} />)
    },
    {
        title: 'Profile',
        path: '/profile',
        icon: (<FontAwesomeIcon icon={faUserAlt} />)
    }
]

export default NavData;
